(function (window, document) {
  "use strict";

  var ZsrbApp = {};

  var iphone = navigator.userAgent.match(/(iPhone\sOS)\s([\d_]+)/);
  var ipad = navigator.userAgent.match(/iPad/);
  if (iphone || ipad) {
    ZsrbApp._setup = function setupWebViewJavascriptBridge(callback) {
      if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge);
      }
      if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
      }
      window.WVJBCallbacks = [callback];
      var WVJBIframe = document.createElement("iframe");
      WVJBIframe.style.display = "none";
      WVJBIframe.src = "https://__bridge_loaded__";
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe);
      }, 0);
    };
  } else {
    ZsrbApp._setup = function connectWebViewJavascriptBridge(callback) {
      if (window.WebViewJavascriptBridge) {
        callback(window.WebViewJavascriptBridge);
      } else {
        document.addEventListener(
          "WebViewJavascriptBridgeReady",
          function () {
            callback(window.WebViewJavascriptBridge);
          },
          false
        );
      }
    };
  }

  ZsrbApp.call = function (method, args, callback) {
    ZsrbApp._setup(function (bridge) {
      bridge.callHandler(method, args, callback);
    });
  };

  window.ZsrbApp = ZsrbApp;
})(window, document);
